import React from 'react';
import { Zap } from 'lucide-react';
import type { Contact } from '../../../../types/contact.types';
import { useAskRemiStore } from '../../../../stores/useAskRemiStore';

interface SummarizeButtonProps {
  contact: Contact;
}

/**
 * Hero pill that opens AskRemi with a full-summary prompt prefilled.
 * Sized to match the CrmSourceIndicator badge so the two sit on the same
 * baseline next to the contact name.
 */
export const SummarizeButton: React.FC<SummarizeButtonProps> = ({ contact }) => {
  const { openModal, sendMessage } = useAskRemiStore();

  const handleClick = () => {
    const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
    const label = fullName || contact.phoneNumber || contact.id;
    openModal();
    sendMessage(`Give me a complete summary of ${label} (contact_id: ${contact.id})`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="summarize-pill shadow-sm h-5 sm:h-6 inline-flex w-fit items-center gap-1 text-[11px] font-medium px-2 sm:px-2.5 rounded-full whitespace-nowrap transition-opacity hover:opacity-90"
    >
      <Zap className="w-3 h-3" />
      Ask Remi
    </button>
  );
};
